import React from 'react';
import styles from './Input.module.css';

const Input = React.forwardRef(({ icon: Icon, placeholder, type = 'text', ...props }, ref) => {
    return (
        <div className={styles.container}>
            <input
                ref={ref}
                type={type}
                placeholder={placeholder}
                className={styles.input}
                {...props}
            />
            {Icon && <Icon className={styles.icon} size={20} />}
        </div>
    );
});

Input.displayName = 'Input'; // tốt cho debug

export default Input;